export default "__VITE_ASSET__DxqU1eEW__"